import React from 'react';
import { PageStructure } from "../../pages";
import {
    PropertyOrder as PropertyOrderComponent
} from "../../components";

const PropertyOrder = () => {
    return (
        <PageStructure>
            <PropertyOrderComponent />
        </PageStructure>
    );
};

export default PropertyOrder;